/* eslint-disable import/prefer-default-export */
export const SMS_URL = 'https://slot.tizeti.com/geniatechapi/index.php';
